import { Button, Grid, SvgIcon } from '@mui/material'
import React from 'react'
import { StepComponentProps } from 'react-step-builder'

interface Props extends StepComponentProps {
  onPressNext(): any
  hidePrev?: boolean
  disabled?: boolean
}

export default function NavigationFooter(props: Props) {
  const { onPressNext, hidePrev, disabled, prev } = props

  const handlePressNext = () => {
    if (onPressNext) return onPressNext()
    props.next()
  }

  return (
    <Grid container direction="row" spacing={2} justifyContent="flex-end" alignItems="flex-end">
      <Grid item>
        {props.hasPrev() && !hidePrev && (
          <Button
            variant="contained"
            onClick={prev}
            disabled={disabled}
            sx={{ height: '55px', minWidth: '55px' }}
            color="secondary"
            endIcon={
              <SvgIcon sx={{ fontSize: '24px', position: 'absolute', left: '16px', top: '16px' }} viewBox="0 0 24 20">
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none">
                  <path
                    d="M22 11.3156C22.7266 11.3156 23.3156 10.7266 23.3156 10C23.3156 9.27342 22.7266 8.68441 22 8.68441L22 11.3156ZM1.06974 9.06974C0.555971 9.58351 0.555971 10.4165 1.06974 10.9303L9.44208 19.3026C9.95585 19.8164 10.7888 19.8164 11.3026 19.3026C11.8164 18.7888 11.8164 17.9559 11.3026 17.4421L3.86052 10L11.3026 2.55791C11.8164 2.04415 11.8164 1.21116 11.3026 0.697393C10.7888 0.183625 9.95585 0.183625 9.44209 0.697393L1.06974 9.06974ZM22 8.68441L2 8.68441L2 11.3156L22 11.3156L22 8.68441Z"
                    fill="white"
                  />
                </svg>
              </SvgIcon>
            }
          />
        )}
      </Grid>
      <Grid item>
        {props.hasNext() && (
          <Button
            sx={{ width: '250px' }}
            variant="contained"
            onClick={handlePressNext}
            disabled={disabled}
            endIcon={
              <SvgIcon sx={{ fontSize: '24px', position: 'absolute', right: '33px', top: '16px' }} viewBox="0 0 24 20">
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none">
                  <path
                    d="M2 8.68441C1.27342 8.68441 0.684413 9.27342 0.684413 10C0.684413 10.7266 1.27342 11.3156 2 11.3156L2 8.68441ZM22.9303 10.9303C23.444 10.4165 23.444 9.58351 22.9303 9.06974L14.5579 0.697395C14.0441 0.183627 13.2112 0.183627 12.6974 0.697395C12.1836 1.21116 12.1836 2.04415 12.6974 2.55792L20.1395 10L12.6974 17.4421C12.1836 17.9559 12.1836 18.7888 12.6974 19.3026C13.2112 19.8164 14.0441 19.8164 14.5579 19.3026L22.9303 10.9303ZM2 11.3156L22 11.3156L22 8.68441L2 8.68441L2 11.3156Z"
                    fill="white"
                  />
                </svg>
              </SvgIcon>
            }
          >
            Next
          </Button>
        )}
      </Grid>
    </Grid>
  )
}
